import { Button } from '@factorialco/deprecated-design-system'
import {
  CompetenciesEditCompetencyGroupDocument,
  CompetenciesEditGroupFragment,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useForm } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type FormData = {
  id: string
  name: string
}

interface Props {
  onClose: () => void
  item: CompetenciesEditGroupFragment
}

export const EditCompetencyGroupModal: React.FC<Props> = ({ item, onClose }) => {
  const [update] = useMutation(CompetenciesEditCompetencyGroupDocument, {
    extractorFn: (data) => data.competenciesMutations.updateCompetenciesCompetencyGroup,
  })

  const form = useForm<FormData>({
    defaultValues: {
      id: item.id,
      name: item.name,
    },
    async onSubmit(values, { setErrors }) {
      const result = await update({
        variables: {
          id: item.id,
          name: values.name,
        },
      })

      const handled = handleResult(result, (errors) => setErrors(errors))

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        track(trackingEvents.competencies.editCompetencyGroup)

        onClose()
      }

      return handled
    },
  })

  return (
    <Modal
      title={i18n.t('competencies_v3.edit_competency_group.title')}
      description={i18n.t('competencies_v3.edit_competency_group.description')}
      illustration="new-folder"
      onClose={onClose}
      onSubmit={() => form.handleSubmit()}
      footer={
        <Button disabled={form.isSubmitting} submit>
          {i18n.t('common.save')}
        </Button>
      }
    >
      <TextField
        label={i18n.t('competencies_v3.edit_competency_group.name_label')}
        value={form.values.name}
        onChange={(value) => form.setFieldValue('name', value)}
        error={form.errors.name}
        mandatory
      />
    </Modal>
  )
}
